module.exports = "https://r.zoocdn.com/_next/static/images/map-dynamic-small-purple-pin-ballon-with-outline-f1a322a67dddd49433064e9ffe480008.svg";